import React, { useState } from 'react';

// AI Confidence badge + popover for answer file chips — exact copy of the Allocation Review (autoFillStepper) badge/popover, driven by file.aiMatch saved during auto-fill
const AiConfidenceBadge = ({ aiMatch, fileName }) => {
    const [aiPopover, setAiPopover] = useState(null);

    if (!aiMatch || !aiMatch.matchScore) return null;

    const matchScore = aiMatch.matchScore;
    const reasoning = aiMatch.reasoning || '';
    const scoreVal = matchScore ? Math.round(matchScore * 10) : null;
    const scoreColor = !scoreVal ? '#9CA3AF' : scoreVal >= 8 ? '#16a34a' : scoreVal >= 6 ? '#d97706' : '#dc2626';
    const scoreLabel = !scoreVal ? '' : scoreVal >= 8 ? 'High' : scoreVal >= 6 ? 'Medium' : 'Low';
    const popoverData = { fileName, reasoning, scoreVal, scoreColor, scoreLabel, isUnallocated: false };

    return (
        <>
            <span
                onMouseEnter={e => { const r = e.currentTarget.getBoundingClientRect(); setAiPopover(p => p?.pinned ? p : { ...popoverData, x: r.left, y: r.bottom, pinned: false }); }}
                onMouseLeave={() => setAiPopover(p => p?.pinned ? p : null)}
                onClick={e => { e.preventDefault(); e.stopPropagation(); const r = e.currentTarget.getBoundingClientRect(); setAiPopover(p => p?.pinned ? null : { ...popoverData, x: r.left, y: r.bottom, pinned: true }); }}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: scoreColor + '18', border: '1px solid ' + scoreColor + '40', borderRadius: 12, padding: '3px 9px', cursor: 'pointer', flexShrink: 0, marginLeft: '0.5rem', marginRight: '0.25rem' }}
            >
                <img src={require('../../../../images/intelligentiaIcon.png')} alt="icon" style={{ width: 20, height: 20 }} />
                <span style={{ fontSize: 12, fontWeight: 700, color: scoreColor }}>{scoreVal || '?'}</span>
            </span>
            {/* AI Confidence Popover */}
            {aiPopover && (
                <div onClick={() => { if (aiPopover.pinned) setAiPopover(null); }} style={{ position: 'fixed', inset: 0, zIndex: 9999, pointerEvents: aiPopover.pinned ? 'auto' : 'none' }}>
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            top: Math.max(8, aiPopover.y - 280),
                            left: Math.min(Math.max(aiPopover.x - 260, 8), window.innerWidth - 296),
                            width: '280px',
                            background: '#fff',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                            padding: '1rem',
                            zIndex: 10000,
                            border: '1px solid #E5E7EB',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <img src={require('../../../../images/intelligentiaIcon.png')} alt="icon" className="w20px h20px mr0-5rem" />
                                <span style={{ fontWeight: 700, fontSize: '13px', color: '#111827' }}>{aiPopover.isUnallocated ? 'Why Unallocated?' : 'AI Confidence'}</span>
                            </div>
                            <span onClick={() => setAiPopover(null)} style={{ cursor: 'pointer', color: '#9CA3AF', fontSize: '14px', lineHeight: 1 }}>✕</span>
                        </div>
                        <div style={{ height: '1px', background: '#F3F4F6', marginBottom: '0.75rem' }} />
                        <div style={{ marginBottom: '0.75rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                <span style={{ fontSize: '12px', color: '#6B7280' }}>{aiPopover.isUnallocated ? 'Confidence score' : 'Match score'}</span>
                                <span style={{ fontSize: '13px', fontWeight: 700, color: aiPopover.scoreColor }}>{aiPopover.scoreVal ? aiPopover.scoreVal : '—'}{aiPopover.scoreLabel ? ' — ' + aiPopover.scoreLabel : ''}</span>
                            </div>
                            <div style={{ height: '6px', borderRadius: '99px', background: '#F3F4F6', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: `${(aiPopover.scoreVal || 0) * 10}%`, background: aiPopover.scoreColor, borderRadius: '99px', transition: 'width 0.4s ease' }} />
                            </div>
                        </div>
                        <div style={{ height: '1px', background: '#F3F4F6', marginBottom: '0.75rem' }} />
                        {aiPopover.isUnallocated ? (
                            <div>
                                <p style={{ fontSize: '11px', fontWeight: 600, color: '#6B7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>AI Reasoning</p>
                                <p style={{ fontSize: '12px', color: '#374151', lineHeight: 1.5, margin: aiPopover.suggestedQNo ? '0 0 8px' : 0 }}>
                                    {aiPopover.fileName && <span style={{ fontWeight: 700, wordBreak: 'break-all' }}>{aiPopover.fileName}</span>}
                                    {aiPopover.fileName && ' - '}
                                    {aiPopover.reasoning || 'Confidence too low to allocate automatically.'}
                                </p>
                                {aiPopover.suggestedQNo && (
                                    <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '7px', padding: '6px 10px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: 600, color: '#1D4ED8', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Possible match</p>
                                        <p style={{ fontSize: '12px', color: '#1E40AF', lineHeight: 1.5, margin: 0 }}>
                                            {aiPopover.suggestedQNo}{aiPopover.suggestedSection ? ' — ' + aiPopover.suggestedSection : ''}{aiPopover.suggestedQuestion ? ': ' + aiPopover.suggestedQuestion : ''}
                                        </p>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <p style={{ fontSize: '11px', fontWeight: 600, color: '#6B7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Why this section?</p>
                                <p style={{ fontSize: '12px', color: '#374151', lineHeight: 1.5, margin: 0 }}>
                                    {aiPopover.fileName && <span style={{ fontWeight: 700, wordBreak: 'break-all' }}>{aiPopover.fileName}</span>}
                                    {aiPopover.fileName && ' - '}
                                    {(() => { const r = aiPopover.reasoning || 'No reasoning provided.'; const match = r.match(/(Claude: \d+\/10 \| GPT: \d+\/10 \| Final: \d+\/10)$/); if (!match) return r; return <>{r.replace(match[1], '').trim()} <span style={{ fontWeight: 700, color: '#151313' }}>{match[1]}</span></>; })()}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default AiConfidenceBadge;
